<div class="modal-header">
  <h4 class="modal-title cs-modal-title"> {{ messageHeader }} </h4>
  <button type="button" class="close" aria-label="Close" (click)="dialog.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body game-modal">
  <div class="form-group">
    <span> {{ messageContent }} </span>
  </div>
</div>
<div class="modal-footer d-flex">
  <button (click)="onCancel()" type="button" class="btn btn-secondary">Cancel</button>
</div>
